import type { Attendance } from "./inquiry";

export const THANKS_MENUS = [
  { value: "comfort", label: "Α" },
  { value: "social", label: "Β" },
  { value: "nagia", label: "Γ" },
] as const;

export const THANKS_CHOICE_LINE = "Επιλέξτε ένα από τα 3 διαθέσιμα μενού: το Α, το Β ή το Γ.";

export type ThanksMenu = (typeof THANKS_MENUS)[number]["value"];

export type ThanksStatus = {
  state: "scheduled" | "sent";
  due_at: string;
  due_label: string;
  sent_at: string | null;
  menu: ThanksMenu | null;
  menu_label: string | null;
};

const HOURS = 4;

export function thanksDueAt(now: Date): string {
  return new Date(now.getTime() + HOURS * 60 * 60 * 1000).toISOString();
}

export function houseBrand(choice: string | null | undefined): string | null {
  if (choice === "casa") return "CASA";
  if (choice === "ktema") return "ΚΤΗΜΑ";
  if (choice === "regina") return "REGINA";
  return null;
}

export function thanksMenuLabel(value: string | null | undefined): string | null {
  return THANKS_MENUS.find((menu) => menu.value === value)?.label ?? null;
}

export function clientEmails(values: (string | null | undefined)[]): string[] {
  const seen = new Set<string>();
  const emails: string[] = [];
  for (const value of values) {
    const email = (value ?? "").trim().toLowerCase();
    if (!email.includes("@") || email.length > 200 || seen.has(email)) continue;
    seen.add(email);
    emails.push(email);
  }
  return emails;
}

/** A new step-3 save or a new «Ήρθε» after deploy. Missed and postponed visits stay quiet. */
export function thanksTrigger(input: {
  previousStep: number;
  nextStep: number;
  previousAttendance: Attendance | null;
  nextAttendance: Attendance | null;
  emails: string[];
}): boolean {
  if (input.emails.length === 0) return false;
  if (input.nextAttendance === "missed" || input.nextAttendance === "postponed") return false;
  const stepped = input.previousStep < 3 && input.nextStep >= 3;
  const came = input.previousAttendance !== "came" && input.nextAttendance === "came";
  return stepped || came;
}

export function thanksMessage(brand: string | null, link: string): { subject: string; text: string; html: string } {
  const house = brand ? ` στο ${brand}` : "";
  const sign = brand ?? "Η ομάδα μας";
  const subject = brand ? `Ευχαριστούμε για τη γευσιγνωσία στο ${brand}` : "Ευχαριστούμε για τη γευσιγνωσία";
  const text = [
    "Καλησπέρα,",
    "",
    `Σας ευχαριστούμε που ήρθατε στη γευσιγνωσία${house}. Χαρήκαμε που σας γνωρίσαμε.`,
    "",
    THANKS_CHOICE_LINE,
    link,
    "",
    "Με εκτίμηση,",
    sign,
  ].join("\n");
  const safeLink = escapeHtml(link);
  const html = [
    "<p>Καλησπέρα,</p>",
    `<p>Σας ευχαριστούμε που ήρθατε στη γευσιγνωσία${escapeHtml(house)}. Χαρήκαμε που σας γνωρίσαμε.</p>`,
    `<p>${THANKS_CHOICE_LINE}</p>`,
    `<p><a href="${safeLink}">Διαλέξτε το Α, το Β ή το Γ</a></p>`,
    `<p>Με εκτίμηση,<br>${escapeHtml(sign)}</p>`,
  ].join("");
  return { subject, text, html };
}

function escapeHtml(value: string): string {
  return value.replaceAll("&", "&amp;").replaceAll("<", "&lt;").replaceAll(">", "&gt;").replaceAll('"', "&quot;");
}
